import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import HistorialConsultas from './components/HistorialConsultas';
import HistorialDescargas from './components/HistorialDescargas';
import HistorialAdjuntos from './components/HistorialAdjuntos';
import useMyHistory from './hooks/useMyHistory';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`cdd-agente-tabpanel-${index}`}
            aria-labelledby={`cdd-agente-tab-${index}`}
            style={{ height: 'calc(100% - 49px)' }} //
            {...other}
        >
            {value === index && <Box sx={{ pt: 2, height: '100%' }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `cdd-agente-tab-${index}`,
        'aria-controls': `cdd-agente-tabpanel-${index}`
    };
}

function UserHistoryContainer({ openDrawer }: any) {
    const { requestsHistory, downloadHistory, attachmentHistory, handleChange, value, loading } =
        useMyHistory({
            openDrawer
        });

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs className="history-tabs" value={value} onChange={handleChange}>
                    <Tab label="Consultas" {...a11yProps(0)} />
                    <Tab label="Descargas" {...a11yProps(1)} />
                    <Tab label="Adjuntos" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <HistorialConsultas items={requestsHistory} loading={loading} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <HistorialDescargas items={downloadHistory} loading={loading} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <HistorialAdjuntos items={attachmentHistory} loading={loading} />
            </CustomTabPanel>
        </Box>
    );
}

export default UserHistoryContainer;
